// extracted by mini-css-extract-plugin
export default {"cardline":"CardLine_cardline__ZMH22","link":"CardLine_link__M0IEU"};